import styled, { css } from "styled-components";

export const CardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  height: 100%;
`;

export const CardLabel = styled.p`
  color: ${({ theme }) => theme.colors.default[900]};
  font-size: 24px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.72px;
`;

export const CardSubheading = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primary[600]};
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.48px;
`;

export const CardContainer = styled.button<{ $selected?: boolean }>`
  padding: 24px;
  display: flex;
  background: ${({ theme }) => theme.colors.default[50]};
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  outline: 2px solid transparent;
  ${({ $selected, theme }) =>
    $selected &&
    css`
      background: ${({ theme }) => theme.colors.default[100]};
      outline-color: ${theme.colors.primary.default};
    `}
  ${({ theme }) => theme.breakpoints.sm.query} {
    padding: 12px 24px;
    ${CardTextContainer} {
      gap: 4px;
    }
  }
`;
